import { Column } from 'react-table';

export const generateCSVColumns = (csvHeaders: string[]): Column<Record<string, string>>[] => {
    return csvHeaders.map(header => ({
        Header: header,
        accessor: header
    }));
};
